module.exports = __webpack_public_path__ + "7c38be7c2d2914557247f2717702f9f3.svg";